module.exports = __webpack_public_path__ + "static/media/Powered by Stripe - blurple.47cc6a78.svg";